import { Alert, Box, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Settings, User } from "../../generated/api";
import { isPrivileged } from "../../util/PrivilegeUtil";

export default function MissingAuthorization() {
  const [errorText, setErrorText] = useState("");
  const user: User = useSelector((state: any) => state.session.currentUser);
  const settings: Settings = useSelector(
    (state: any) => state.settings.internalSettings
  );
  const { t } = useTranslation();

  useEffect(() => {
    if (
      !user?.commissionHsaId &&
      !isPrivileged(user?.privileges, "EFK.CARD", "READ")
    ) {
      setErrorText(t("errors.authorization.both"));
    } else if (!user?.commissionHsaId) {
      setErrorText(t("errors.authorization.commission"));
    } else if (!isPrivileged(user?.privileges, "EFK.CARD", "READ")) {
      setErrorText(t("errors.authorization.systemrole"));
    }
  }, [user, t]);

  return (
    <Stack sx={{ mt: 5 }} direction="column" alignItems="center" spacing={1}>
      <Box textAlign="center">
        <Alert severity="error">
          <Typography variant="h5">{errorText}</Typography>
          <Typography sx={{ mt: 1 }}>
            {t("errors.authorization.common")}
          </Typography>
          <a href={settings.errorHelpURL}>
            {t("errors.authorization.moreinfo")}
          </a>
        </Alert>
      </Box>
    </Stack>
  );
}
